export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promotions-deposit.vue?vue&type=template&id=090c369a"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/promotions/promotions-deposit.vue?vue&type=template&id=090c369a
// module id = iVpT
// module chunks = 0